// update THIS on new version publish
const VERSION = "1.0.13";

export const MAC_DOWNLOAD = `https://github.com/arlisonlabs/block-forever-public/releases/download/v${VERSION}/BlockForever-${VERSION}.dmg`;
